import type {PositionSide} from '../types';

export function toPosSide(direction: 1 | -1 | 0): PositionSide | null {
    if (1 === direction) return 'long';
    if (-1 === direction) return 'short';
    return null;
}

export function toOrderSide(posSide: PositionSide): 'buy' | 'sell' {
    return 'long' === posSide ? 'buy' : 'sell';
}

export function directionLabel(dir: number): string {
    if (1 === dir) return '看多';
    if (-1 === dir) return '看空';
    return '中性';
}

export function calcProfitLossRatio(
    entry: number,
    target: number,
    stopLoss: number,
): number {
    const upside = Math.abs(target - entry);
    const downside = Math.abs(entry - stopLoss);
    if (0 === downside || 0 === upside) return 0;
    return Math.round((upside / downside) * 100) / 100;
}

export function validatePriceRelation(
    posSide: PositionSide,
    entry: number,
    target: number,
    stop: number,
): boolean {
    if ('long' === posSide) {
        return target > entry && entry > stop;
    }
    return target < entry && entry < stop;
}
